/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentTypeSerializerDetail } from './appointmentTypeSerializerDetail';
import { SyncStatusDetail } from './syncStatusDetail';
import { CancellationReasonEnum } from './cancellationReasonEnum';
import { AppointmentBlockerTherapist } from './appointmentBlockerTherapist';
import { ExternalSystemEnum } from './externalSystemEnum';
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { CalendarPatient } from './calendarPatient';


/**
 * Serializer for the Appointment model. Used by the calendar view.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSerializerDetail { 
    readonly id: number;
    startDate: string;
    readonly endDate: string;
    readonly appointmentStatus: AppointmentStatusEnum;
    appointmentType: AppointmentTypeSerializerDetail;
    readonly cancellationReason: CancellationReasonEnum | null;
    cancellationReasonOther?: string | null;
    readonly externalSystem: ExternalSystemEnum | null;
    patients: Array<CalendarPatient>;
    organization: AppointmentBlockerTherapist;
    therapist: AppointmentBlockerTherapist;
    readonly patientFileUrl: string;
    readonly syncStatus: SyncStatusDetail;
    readonly isRetrying: boolean;
    readonly isFirstSession: boolean;
}
export namespace AppointmentSerializerDetail {
}

export const AppointmentSerializerDetail_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_endDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_appointmentStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_appointmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_cancellationReason_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_cancellationReasonOther_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const AppointmentSerializerDetail_externalSystem_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_patients_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_organization_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_patientFileUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_syncStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_isRetrying_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSerializerDetail_isFirstSession_Validators: ValidatorFn[] =
    [  Validators.required, ];


